import React, { ReactElement } from 'react';

export default function Label(
  props: {
    label?: string | ReactElement,
    bold?: boolean
    className?: string
  },
) {
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {props.label && (
        <div className={`label ${props.bold ? ' bold' : ''} ${props.className}`}>
          <span className={`label-text`}>{props.label}</span>
        </div>
      )}
    </>
  );
}
